import React, { useCallback } from 'react';
import Router from 'next/router';
import { proxy, useSnapshot } from 'valtio';
import { enumChecker } from '@soundxyz/utils/const';
import { createContainer } from '../utils/unstated';
import { ParamsStore } from './params';

export const ModalType = {
  ARTIST_BIO_MODAL: 'ARTIST_BIO_MODAL',
  FOLLOWERS_FOLLOWING: 'FOLLOWERS_FOLLOWING',
  FOLLOWERS: 'FOLLOWERS',
  FOLLOWING: 'FOLLOWING',
  DELETE: 'DELETE',
  VERIFY_TWITTER: 'VERIFY_TWITTER',
  REMOVE_TWITTER_VERIFICATION: 'REMOVE_TWITTER_VERIFICATION',
  REMOVE_INSTAGRAM_VERIFICATION: 'REMOVE_INSTAGRAM_VERIFICATION',
  PROCESSING: 'PROCESSING',
  LIVE_RELEASE_PARTY: 'LIVE_RELEASE_PARTY',
  VERIFY_ACCOUNT: 'VERIFY_ACCOUNT',
  IMAGE_CROP: 'IMAGE_CROP',
  ARTIST_COLLECTED_BY: 'ARTIST_COLLECTED_BY',
  ACTIVITY_COLLECTED_BY: 'ACTIVITY_COLLECTED_BY',
  PLAYLIST_LIKERS: 'PLAYLIST_LIKERS',
  BUY_NFT: 'BUY_NFT',
  SET_TIMESLOT: 'SET_TIMESLOT',
  SET_COMMENT: 'SET_COMMENT',
  SHARE_TO_SOCIAL: 'SHARE_TO_SOCIAL',
  SELECT_EDITION: 'SELECT_EDITION',
  MULTIPLE_NFTS_COMMENT: 'MULTIPLE_NFTS_COMMENT',
  RELEASE_NOTIFICATION: 'RELEASE_NOTIFICATION',
  WITHDRAW_FUNDS_MULTIPLE: 'WITHDRAW_FUNDS_MULTIPLE',
  WITHDRAW_FUNDS: 'WITHDRAW_FUNDS',
  WITHDRAW_ALL: 'WITHDRAW_ALL',
  VERIFY_TWITTER_STEP_ONE: 'VERIFY_TWITTER_STEP_ONE',
  VERIFY_TWITTER_STEP_TWO: 'VERIFY_TWITTER_STEP_TWO',
  IMAGE_UPLOAD: 'IMAGE_UPLOAD',
  IMAGE_VIEW: 'IMAGE_VIEW',
  CREDITS: 'CREDITS',
  UPLOAD_WHITELIST: 'UPLOAD_WHITELIST',
  VIEW_WHITELIST: 'VIEW_WHITELIST',
  UPDATE_SONG_MODAL: 'UPDATE_SONG_MODAL',
  PROCESSING_UPLOAD_JOURNEY: 'PROCESSING_UPLOAD_JOURNEY',
  UPLOAD_SUCCESS: 'UPLOAD_SUCCESS',
  SONG_REWARD: 'SONG_REWARD',
  ADD_TO_PLAYLIST: 'ADD_TO_PLAYLIST',
  DELETE_SHELF: 'DELETE_SHELF',
  CONFIRM_WITHDRAWAL: 'CONFIRM_WITHDRAWAL',
  PLAYLIST_ACTIONS: 'PLAYLIST_ACTIONS',
  EMBED: 'EMBED',
  SHARE: 'SHARE',
  CLEAR_ADDRESSESS: 'CLEAR_ADDRESSES',
  DRAFT_ALLOWLIST: 'DRAFT_ALLOWLIST',
  RELEASE_ALLOWLIST: 'RELEASE_ALLOWLIST',
  MANAGE_REFERRALS: 'MANAGE_REFERRALS',
  REFERRALS_COLLECTORS: 'REFERRALS_COLLECTORS',
  MANAGE_AUDIO_DOWNLOAD: 'MANAGE_AUDIO_DOWNLOAD',
  SAM_TRANSACTION_FAILED: 'SAM_TRANSACTION_FAILED',
  ON_RAMP: 'ON_RAMP',
  SAM_FAQ: 'SAM_FAQ',
  PLAYLIST_DESCRIPTION_MODAL: 'PLAYLIST_DESCRIPTION_MODAL',
  SAM_WITH_CC: 'SAM_WITH_CC',
  PAPER_CC_MINT_MODAL: 'PAPER_CC_MINT_MODAL',
  PAPER_ETH_MINT_MODAL: 'PAPER_ETH_MINT_MODAL',
  CROSSMINT_CC_MINT_MODAL: 'CROSSMINT_CC_MINT_MODAL',
  RELEASE_MINTS: 'RELEASE_MINTS',
  ARTIST_APPLICATION_SUBMITTED: 'ARTIST_APPLICATION_SUBMITTED',
  ARTIST_APPLICATION_REJECTED: 'ARTIST_APPLICATION_REJECTED',
  ARTIST_APPLICATION_CONFIRMATION: 'ARTIST_APPLICATION_CONFIRMATION',
  NOTIFICATIONS_EMAIL_INPUT: 'NOTIFICATIONS_EMAIL_INPUT',
  NOTIFICATIONS_EMAIL_CONFIRMATION: 'NOTIFICATIONS_EMAIL_CONFIRMATION',
  SUBSCRIBED_ARTISTS: 'SUBSCRIBED_ARTISTS',
  REJECT_ARTIST_APPLICATION: 'REJECT_ARTIST_APPLICATION',
  INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
  INSUFFICIENT_FUNDS_OPTIMISM: 'INSUFFICIENT_FUNDS_OPTIMISM',
  INSUFFICIENT_FUNDS_OPTIMISM_DEPLOY: 'INSUFFICIENT_FUNDS_OPTIMISM_DEPLOY',
  INSUFFICIENT_FUNDS_ETH: 'INSUFFICIENT_FUNDS_ETH',
  SWITCH_NETWORK: 'SWITCH_NETWORK',
  READY_TO_DEPLOY: 'READY_TO_DEPLOY',
  WITHDRAW_CREATOR_EARNINGS: 'WITHDRAW_CREATOR_EARNINGS',
  WITHDRAW_REFERRAL_EARNINGS: 'WITHDRAW_REFERRAL_EARNINGS',
  COLLECTED_RELEASES: 'COLLECTED_RELEASES',
  ARTISTS_BACKED: 'ARTISTS_BACKED',
  ARTIST_COLLECTORS_MINTS: 'ARTIST_COLLECTORS_MINTS',
  SHARE_PROFILE_ON_TWITTER: 'SHARE_PROFILE_ON_TWITTER',
  CROSSMINT_PROCESSING: 'CROSSMINT_PROCESSING',
  PAPER_PROCESSING: 'PAPER_PROCESSING',
  TIER_LEARN_MORE: 'TIER_LEARN_MORE',
  AUDIO_PLAYER_COLLECT: 'AUDIO_PLAYER_COLLECT',
  RELEASE_CHECKOUT: 'RELEASE_CHECKOUT',
  SHARE_SONG_IMAGE: 'SHARE_SONG_IMAGE',
  SIGN_IN_WITH_WALLET: 'SIGN_IN_WITH_WALLET',
  UPLOAD_GA_EDITION_LEARN_MORE: 'UPLOAD_GA_EDITION_LEARN_MORE',
  MINTS_DRIVEN: 'MINTS_DRIVEN',
  BRIDGE_MODAL: 'BRIDGE_MODAL',
  SEND_FUNDS_MODAL: 'SEND_FUNDS_MODAL',
  COLLECT: 'COLLECT',
  EDIT_FEATURED_SOUND: 'EDIT_FEATURED_SOUND',
  COMMENT_MODAL_V2: 'COMMENT_MODAL_V2',
  YOU_OWN: 'YOU_OWN',
  FEED_POST: 'FEED_POST',
  SHARED_FEED_POST: 'SHARED_FEED_POST',
  AFTER_RELEASE_FEED_POST: 'AFTER_RELEASE_FEED_POST',
  AFTER_PLAYLIST_FEED_POST: 'AFTER_PLAYLIST_FEED_POST',
  DELETE_POST_CONFIRMATION: 'DELETE_POST_CONFIRMATION',
  DELETE_ALL_USER_CONTENT_CONFIRM: 'DELETE_ALL_USER_CONTENT_CONFIRM',
  DISCARD_CHANGES_EDIT_FLOW: 'DISCARD_CHANGES_EDIT_FLOW',
  DELETE_POST_COMMENT_CONFIRMATION: 'DELETE_POST_COMMENT_CONFIRMATION',
  UPVOTED_USERS: 'UPVOTED_USERS',
  REPOSTED_USERS: 'REPOSTED_USERS',
  RELEASE_CHECKOUT_GIFT: 'RELEASE_CHECKOUT_GIFT',
  REPLY_POST: 'REPLY_POST',
  UNLOCK_FEED_POST: 'UNLOCK_FEED_POST',
  GIFT_MODAL: 'GIFT_MODAL',
  FEED_POST_COMMENT: 'FEED_POST_COMMENT',
  SETUP_PROFILE: 'SETUP_PROFILE',
} as const;

export const isModalType = enumChecker(ModalType);

export type ModalType = (typeof ModalType)[keyof typeof ModalType];

export type ModalContentState = {
  body: React.ReactNode;
};

const globalModalState = proxy({
  activeModal: null as ModalType | null,
  nextModal: null as ModalType | null,
  modalContent: null as ModalContentState | null,
  setNextModal: (nextModal: ModalType | null) => {
    globalModalState.nextModal = nextModal;
  },
  openModal: (newModalType: ModalType) => {
    globalModalState.activeModal = newModalType;
  },
  onCancelModal: null as (() => void) | null,
  setOnCancelModal: (onCancelModal: () => void | null) => {
    globalModalState.setOnCancelModal = onCancelModal;
  },
  closeModal: () => {
    globalModalState.activeModal = null;
    globalModalState.onCancelModal = null;
    globalModalState.modalContent = null;
    // Clear modal in query params
    ParamsStore.modal = null;
  },
  closeModalByType: (modalType: ModalType) => {
    if (globalModalState.activeModal === modalType) {
      globalModalState.closeModal();
    }
  },
  closeCancelModal: () => {
    if (globalModalState.onCancelModal !== null) {
      globalModalState.onCancelModal();
    }
    globalModalState.closeModal();
  },
});

export const GlobalModal = {
  get activeModal() {
    return globalModalState.activeModal;
  },
};

if (typeof window !== 'undefined') {
  // If leaving the page, close the modal
  Router.events.on('routeChangeStart', (destination: string) => {
    /* need this extra guard because useRouterRefresh triggers routeChangeStart
     * for the route we're already on */
    if (destination !== Router.asPath) {
      globalModalState.closeModal();
    }
  });
}

export const ModalContext = createContainer(function useModal() {
  const openModal = useCallback((modalType: ModalType, modalContent: ModalContentState | null) => {
    setTimeout(() => {
      /**
       * When you trigger opening another modal and the trigger is inside a modal
       * radix adds another 15px to the removed body scroll bar size
       * this is to make sure its always 15px
       */
      document.body.style.setProperty('--removed-body-scroll-bar-size', '15px !important');

      globalModalState.modalContent = modalContent;

      globalModalState.activeModal = modalType;
    }, 100);
  }, []);

  // Used for directing to buy modal after a successful login triggered from attempting to buy (for example)
  React.useEffect(() => {
    if (globalModalState.nextModal && globalModalState.activeModal === null) {
      globalModalState.activeModal = globalModalState.nextModal;
      globalModalState.setNextModal(null);
    }
  }, []);

  const { activeModal, onCancelModal } = useSnapshot(globalModalState);

  return {
    activeModal,
    onCancelModal,
    modalContent: globalModalState.modalContent,
    openModal,
    closeCancelModal: globalModalState.closeCancelModal,
    setOnCancelModal: globalModalState.setOnCancelModal,
    closeModal: globalModalState.closeModal,
    closeModalByType: globalModalState.closeModalByType,
    setNextModal: globalModalState.setNextModal,
  };
});

export const useModal = () => ModalContext.useContainer();
